// Entry point for the build script in your package.json
import "./controllers"

import "./groups"

import { initDeleteHandler } from "./delete_handler"

// Initialize the delete handler to manage deletion links with confirmation and CSRF protection
initDeleteHandler()